import { PipeTransform, Pipe } from '@angular/core';
import { ImpacterReference } from '../../models/reference';

@Pipe({ name: 'reference' })
export class ReferencePipe implements PipeTransform {
  transform(text: string, impacters: ImpacterReference[]): any {
    // Return the final transformed text
    return impacters.reduce((accumulatedImpactersResult, impacter) => {
      // For each unique mention, replace the mention by a referenced link
      return [...new Set(impacter.mentions.map((mention) => mention.name))].reduce((
        accumulatedMentionsResult,
        mention
      ) => accumulatedMentionsResult.replace(
        new RegExp(mention, 'g'),
        (value) => `<a target="_blank" href="${impacter.explainUrl}" class="mention ref-id-${impacter.id}">${value}</a>`
      ), accumulatedImpactersResult);
    }, text);
  }
}
